import env from './env';

export default {
  publicKey: env('FLYBASE_PUBLIC_KEY', ''),
  baseUrl: env('FLYBASE_BASE_URL', 'https://api.flystart.io'),
  frontendBaseUrl: env('FLYBASE_FRONTEND_BASE_URL', 'https://flystart.io'),
  redirectRoute: env('FLYBASE_OAUTH_REDIRECT_ROUTE', '/loggedin'),
  oAuthEnabled: env('FLYBASE_OAUTH_ENABLED', false),
};
